import { render } from "./RegistrationMainInfo.vue?vue&type=template&id=47ef73c1&scoped=true"
import script from "./RegistrationMainInfo.vue?vue&type=script&lang=js"
export * from "./RegistrationMainInfo.vue?vue&type=script&lang=js"

import "./RegistrationMainInfo.vue?vue&type=style&index=0&id=47ef73c1&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47ef73c1"]])

export default __exports__